import { REGULARS } from 'utils';

export const getOnlyNumbers = (value: string) => value.match(REGULARS.numbers)?.join('');
